export default "__VITE_ASSET__mRMaTM_x__"